import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../components/authStore';
import { useUserStore } from '../components/userStore';

const Logout = () => {
	const { signOut } = useAuthStore();
	const { updateUser } = useUserStore();
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	useEffect(() => {
		signOut();
		updateUser(null);
		queryClient.clear();
		navigate('/', { replace: true });
	}, []);

	return null;
};

export default Logout;
